import type { RadarDataPoint } from '../components/PositionRadarChart'
import type { PositionAssessmentTimeseriesItem } from '../types'

/**
 * Process latest timeseries data for radar chart display.
 * Extracts category scores for manager and self from the most recent assessment.
 */
export const processLatestData = (
  timeseries: Array<PositionAssessmentTimeseriesItem> | undefined,
): Array<RadarDataPoint> => {
  if (!timeseries || timeseries.length === 0) return []

  const managerData = timeseries.find((item) => item.responseType === 'manager')
  const selfData = timeseries.find((item) => item.responseType === 'self')

  const categories = [
    { key: 'talentAvg', label: 'Talent' },
    { key: 'craftAvg', label: 'Craft' },
    { key: 'resultsAvg', label: 'Results' },
    { key: 'directionAvg', label: 'Direction' },
    { key: 'cultureAvg', label: 'Culture' },
  ]

  return categories.map(({ key, label }) => ({
    category: label,
    manager: managerData?.[key as keyof PositionAssessmentTimeseriesItem]
      ? parseFloat(
          managerData[key as keyof PositionAssessmentTimeseriesItem] as string,
        )
      : 0,
    self: selfData?.[key as keyof PositionAssessmentTimeseriesItem]
      ? parseFloat(
          selfData[key as keyof PositionAssessmentTimeseriesItem] as string,
        )
      : 0,
  }))
}
